export { strategies, StrategiesType } from './strategies';
